<template>
  <div class="app-container">
    <list ref="list">
       
       
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/materialsummary/list'


export default {
  name: 'materialsummary',
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
    }
  },
  
};
</script>